<shrd-pf-ui-header-user-info-button
  *ngFor="let account of accounts; trackBy: trackById"
  [showUserName]="false"
  [userAccount]="account"
  [omitUserTitle]="true"
  [accountIsSelectable]="true"
  [isSelected]="account.originId === selectedAccountId"
  [disabled]="disabled"
  (showAccountDetails)="onSelectedAccountChanged(account.originId)"
></shrd-pf-ui-header-user-info-button>

<form *ngIf="inHostContext" class="d-none" action="/select-account" method="post" #selectAccountForm>
  <input type="hidden" name="selectNumber" [value]="accountId" />
  <input type="hidden" name="returnUrl" [value]="currentUrl" />
  <input type="hidden" name="CSRFToken" [value]="csrfToken" />
</form>
